/**
 * **The date it is where the company is**, as ISO yyyy-mm-dd. The server keeps UTC, and between 22:00 and
 * midnight UTC a Norwegian company is already in tomorrow: a question about *today* asked then would be
 * answered for yesterday. `Intl` knows the zone's rules, summer time included.
 */
export function localDate(at: Date, timeZone: string): string {
  // en-CA writes a date as yyyy-mm-dd; the parts are read rather than the string trusted.
  const parts = new Intl.DateTimeFormat('en-CA', {
    timeZone,
    year: 'numeric',
    month: '2-digit',
    day: '2-digit',
  }).formatToParts(at);
  const part = Object.fromEntries(parts.map((p) => [p.type, p.value]));
  return `${part['year']}-${part['month']}-${part['day']}`;
}
